<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
          <div class="row">
            <div class="col-sm-12 text-center" style="margin-top:50px;">
              <h3>You're Almost Done!</h3>
              <p>Your listing has been saved and is almost ready to go live! Use the subscribe button below to take your listing live.</p>
            </div>
            <div class="col-sm-12 text-center">
              <div class="form-group">
                <pay-pal
                  v-if="listingId > 0"
                  :amount="price"
                  :listingId="listingId"
                ></pay-pal>
                <small>You will be redirected to PayPal upon clicking the subscribe button above</small>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "../nav/NavigationBar";
import DashboardFooter from "../nav/Footer";
import Utils from "@/Utils/Utils";
import Navigator from "@/router/navigator";
import CreateListingStore from "./CreateListingStore";
import AccountSessionUtils from "./AccountSessionUtils";
import moment from "moment";
import PayPal from "@/components/PayPal";
import API from "@/API/API";

export default {
  name: "PayListing",
  components: {
    NavigationBar,
    DashboardFooter,
    PayPal
  },
  data() {
    return {
      nav: Navigator,
      store: CreateListingStore,
      accountUtils: AccountSessionUtils,
      utils: Utils,
      price: "", //price should come from listing because price dollar amount needs to be stored in the listings table
      listingId: 0,
      api: API
    };
  },
  mounted() {
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
        if (userId == "0") {
          this.nav.goRegister(this);
          return;
        }

        var listingId = this.$route.params.listingId;
        if (!listingId) {
          this.nav.goListings();
          return;
        }
        this.getListing(listingId, userId);
      },
      err => {
        this.$toasted.show(err, { type: "error", duration: 2500 });
      },
      () => {
        this.nav.goMaintenance(this);
      }
    );
  },
  computed: {
  },
  methods: {
    getListing: function(listingId, userId) {
      let self = this;
      this.api
        .getListing(userId, listingId)
        .then(function(res) {
          if (res.data) {
            let data = res.data;
            if (data.error) {
              // self.nav.goListings(self)
            } else {
              if (data.maintenanceMode) {
                return;
              }
              if (data.listing.transactionId && !data.listing.cancelled) {
                self.nav.goListings(self);
              }
              self.listingId = data.listing.id;
              self.price = data.listing.price;
            }
          } else {
            // self.nav.goListings(self)
          }
        })
        .catch(e => {
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Hiding the checkbox, but allowing it to be focused */
.badgebox {
  opacity: 0;
}

.badgebox + .badge {
  /* Move the check mark away when unchecked */
  display: none;
  /* Makes the badge's width stay the same checked and unchecked */
  width: 27px;
}

.badgebox:checked + .badge {
  /* Move the check mark back when checked */
  display: block;
}

.badge {
  float: right;
  margin-top: 3px;
  padding-right: 0px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/account/PayListing.vue